import { BasicContainer } from '@/components/Common/BasicContainer/BasicContainer';
import { FormSectionTitle } from '@/components/Form/FormSectionTitle/FormSectionTitle';
import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Box, Button, IconButton, Stack } from '@mui/material';
import { useRemissionViewController } from './RemissionViewController';

export const Remission = () => {
  const { uiState, actions, references } = useRemissionViewController();

  return (
    <Stack spacing="12px" mt="20px" width="100%">
      <FormSectionTitle title="Remisión" />
      <BasicContainer
        content={
          <Box display="flex" justifyContent="center">
            <Box
              sx={{
                width: '100%',
                height: { xs: '200px', lg: '300px' },
                backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='11' ry='11' stroke='%230000001A' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");`,
                borderRadius: '12px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                position: 'relative',
                alignItems: 'center',
                m: '16px',
              }}
            >
              {uiState?.imageUrl ? (
                <>
                  <button
                    style={{
                      border: 'none',
                      background: 'none',
                      padding: '8px',
                      cursor: uiState.imageOpenable ? 'pointer' : 'default',
                      width: '100%',
                      height: '100%',
                    }}
                    onClick={actions.onClickedImage}
                  >
                    <img
                      src={uiState.imageUrl}
                      alt={`productimage`}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                      }}
                    />
                  </button>
                  <Stack
                    sx={{
                      position: 'absolute',
                      top: '8px',
                      right: '8px',
                      direction: 'row',
                    }}
                  >
                    <IconButton
                      size="large"
                      onClick={actions.onClickedEditImage}
                    >
                      <EditOutlinedIcon />
                    </IconButton>
                    <IconButton
                      size="large"
                      onClick={actions.onClickedDeleteImage}
                    >
                      <DeleteOutlineIcon />
                    </IconButton>
                  </Stack>
                </>
              ) : (
                <IconButton size="large" onClick={actions.onClickedEditImage}>
                  <AddPhotoAlternateOutlinedIcon />
                </IconButton>
              )}
              <input
                type="file"
                ref={references.fileInputRef}
                onChange={actions.handleFileChange}
                accept=".png,.jpg,.jpeg"
                style={{ display: 'none' }}
              />
            </Box>
          </Box>
        }
        footer={
          <Box
            sx={{
              textAlign: 'right',
              p: '16px',
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '16px',
            }}
          >
            <Button
              variant="contained"
              onClick={actions.onClickedCancel}
              disabled={uiState.cancelDisabled}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              onClick={actions.onClickedSave}
              disabled={uiState.saveDisabled}
            >
              Guardar cambios
            </Button>
          </Box>
        }
      />
    </Stack>
  );
};
